import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const { totalItems } = useCart();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isSearchResultsPage = location.pathname === '/search-results' || location.pathname === '/SearchResult/SearchResults';

  // Debug: Check if cart icon should display
  console.log('Debug - Path:', location.pathname);
  console.log('Debug - Is search results:', isSearchResultsPage);
  console.log('Debug - Total items:', totalItems);
  console.log('Debug - Should show cart:', isSearchResultsPage && totalItems > 0);

  // Debug: Log current path and cart display status
  console.log('Current path:', location.pathname);
  console.log('Is search results page:', isSearchResultsPage);
  console.log('Cart total items:', totalItems);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg ${isScrolled ? 'nav-scroll' : ''}`}>
      <div className="container">
        {/* Mobile View - Menu Left, Logo Center, Cart Right */}
        {isMobile ? (
          <div className="navbar-mobile-bar">
            <button 
              className="navbar-toggler navbar-mobile-menu" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#navbar" 
              aria-controls="navbar" 
              aria-expanded="false" 
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="ti-menu" style={{ fontSize: '22px', color: isScrolled ? '#333' : '#fff' }}></i>
              </span>
            </button>
            
            <div className="logo-wrapper navbar-mobile-logo">
              <Link className="logo" to="/">
                <img src={isScrolled ? '/img/logos/brown logo.png' : '/img/whitelogo.png'} className="logo-img" alt="Sintra Hotel" />
              </Link>
            </div>
            
            <button
              type="button"
              className="navbar-cart-btn navbar-cart-btn--mobile"
              onClick={() => window.dispatchEvent(new Event('openCart'))}
              aria-label="Open cart"
            >
              <i className="ti-shopping-cart" style={{ fontSize: '20px', color: isScrolled ? '#333' : '#fff' }}></i>
              {totalItems > 0 && (
                <span className="navbar-cart-badge">{totalItems}</span>
              )}
            </button>
          </div>
        ) : (
          /* Desktop View - Original Layout with Cart */
          <>
            <div className="logo-wrapper">
              <Link className="logo" to="/">
                <img src={isScrolled ? '/img/logos/brown logo.png' : '/img/whitelogo.png'} className="logo-img" alt="Sintra Hotel" />
              </Link>
            </div>
            
            {/* Cart Icon for Desktop */}
           
          </>
        )}
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-online-hotel-booking-islamabad">About</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle" 
                href="#" 
                role="button" 
                data-bs-toggle="dropdown" 
                data-bs-auto-close="outside" 
                aria-expanded="false"
              >
                Rooms & Suites<i className="ti-angle-down"></i>
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item">
                  <Link className="dropdown-item" to="/executive-room-at-hotel-islamabad">
                    <span>Executive Room</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/twin-executive-room-at-hotel-islamabad">
                    <span>Twin Executive Room</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/super-deluxe-room-at-hotel-islamabad">
                    <span>Super Deluxe Room</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/sintra-hotel-islamabad-pictures">Gallery</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/room-decor-packages">Decor</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/places-to-visit-in-islamabad-and-fun-activities">Places</Link>
            </li>
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle" 
                href="#" 
                role="button" 
                data-bs-toggle="dropdown" 
                data-bs-auto-close="outside" 
                aria-expanded="false"
              >
                Cafe & Restaurant<i className="ti-angle-down"></i>
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item">
                  <Link className="dropdown-item" to="/spice-fusion-top-restaurant-in-islamabad">
                    Spice Fusion
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="dropdown-item" to="/soir-top-cafe-in-islamabad">
                    Cafe SOIR
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blog-hotel-islamabad-updates">Blog</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/sintra-hotel-islamabad-contact-number">Contact</Link>
            </li>
            <li className="nav-item navbar-cart-item">
              <button
                type="button"
                className="navbar-cart-btn"
                onClick={() => window.dispatchEvent(new Event('openCart'))}
                aria-label="Open cart"
              >
                <i className="ti-shopping-cart" style={{ color: isScrolled ? '#333' : '#fff' }}></i>
                {totalItems > 0 && (
                  <span className="navbar-cart-badge">{totalItems}</span>
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
